module.exports = "/assets/fc2cc7175a56d52df94278912fd5708f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IY.png
// module id = 1491
// module chunks = 0